import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPlans = lazy(() => import("@/pages/admin/AdminPlans"));

export const Route = createFileRoute("/admin/plans")({
  component: AdminPlans,
});
